<template>
    <main id="main">
        <section id="services" :class="['services', 'pb-1', 'mb-1']">
            <div :class="['container']">
                <h3 :class="['text-left', 'font-weight-bold', 'pb-0', 'mb-3']">AGENDA DEL TITULAR DE LA {{empresa.abreviatura}}</h3>
                <div :class="['row']">
                    <div :class="['col-12', 'col-md-12', 'col-sm-12']">
                        <div :class="['card', 'borderTopCard', 'shadow-sm']" >

                            <div :class="['card-body', 'pt-2']">
                                
                                <hr :class="['mt-1', 'mb-3']" />
                                <div :class="['row']">
                                    <div :class="['col-lg-4', 'col-md-6', 'col-sm-5', 'mb-3']">
                                        <div :class="['input-group']">
                                            <div class="input-group-text">
                                                Mes
                                            </div>
                                            <select class="form-control" ref="mes_agenda" v-model="mes_agenda">
                                                <option value="1" >Enero</option>
                                                <option value="2">Febrero</option>
                                                <option value="3">Marzo</option>
                                                <option value="4">Abril</option>
                                                <option value="5">Mayo</option>
                                                <option value="6">Junio</option>
                                                <option value="7">Mayo</option>
                                                <option value="8">Mayo</option>
                                                <option value="9">Mayo</option>
                                                <option value="10" >Octubre</option>
                                                <option value="11" >Noviembre</option>
                                                <option value="12" >Diciembre</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div :class="['col-lg-5', 'col-md-6', 'col-sm-7', 'mb-3']">
                                        <div :class="['input-group']">
                                            <div class="input-group-text">
                                                Año
                                            </div>
                                            <select class="form-control" ref="anio_agenda" v-model="anio_agenda">
                                                <option value="2023">2023</option>
                                            </select>

                                            <div class="input-group-append">
                                                <button type="button" @click="getAgenda" :class="['btn', 'btn-success', 'btn-block']">
                                                    <i :class="['fa', 'fa-search', 'ml-2']" aria-hidden="true"></i>
                                                    Consultar
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div :class="['col-lg-6', 'col-md-8', 'col-sm-8', 'mb-3']">
                                        <h4>Director Regional</h4>
                                        <h4>{{funcionario.nombres}}</h4>
                                    </div>

                                    <div :class="['col-lg-1', 'col-md-3', 'col-sm-4', 'mb-3']">
                                        <img :src="funcionario.foto" style="width:100%;" class="img-thumbnail" alt="">
                                    </div>
                                </div>
                                
                                <div :class="['row']">
                                    <div :class="['col-lg-12', 'mt-4']">
                                        <div class="table-responsive">
                                            <table :class="['table', 'table-bordered']">
                                                <thead>
                                                    <tr style="font-size:12.5px;">
                                                        <th width="10%" class="text-center">Fecha</th>
                                                        <th width="15%" class="text-center">Hora</th>
                                                        <th width="45%" class="text-center">Tarea/ Actividad</th>
                                                        <th width="15%" class="text-center">Lugar</th>
                                                        <th width="15%" class="text-center">Ciudad</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(val, key) in agenda_virtual" :key="key" style="font-size:12px;">
                                                        <td >
                                                            <center>
                                                            {{val.dia_semana}}
                                                            <h3>{{val.dd}}</h3>
                                                            </center>
                                                        </td>

                                                        <td v-if="val.reuniones.length<1" colspan="4">
                                                            <center>SIN ACTIVIDAD</center>
                                                        </td>
                                                        <td v-else colspan="4">
                                                            <table class="table-borderless p-0">
                                                                <tr v-for="(value, k) in val.reuniones" :key="k">
                                                                    <td width="14%">{{value.hora}}</td>
                                                                    <td width="47%">{{value.descripcion}}</td>
                                                                    <td width="16%">{{value.lugar}}</td>
                                                                    <td width="15%">{{value.ciudad}}</td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    
    export default {
        name: 'AgendaTitular',
        components:{

        },
        computed:{
            ...mapState(['loading','globales','empresa']),
            
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Agenda del Titular || "+((this.empresa.abreviatura)?this.empresa.abreviatura:"DRASAM");
            this.getAgenda();
        },
        data(){
            return{
                mes_agenda:this.str_pad(parseInt(this.mes_actual())+1, 2 ,'0'),
                anio_agenda:2023,
                resultado_visitas:[],
                agenda_virtual:[],
                filas_tabla:[],
                funcionario:{
                    "nombres":"Ing. ",
                    "foto": "",
                },
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),

            getAgenda(){
                if(!this.mes_agenda){
                    this.$refs.mes_agenda.focus();
					return;
                }

                if(!this.anio_agenda){
                    this.$refs.anio_agenda.focus();
					return;
                }
                let parametros = "funcionario_id=DRA-001&mes="+this.mes_agenda+"&anio="+this.anio_agenda;

                this.setLoading(true);

                this.$http.get('webserviceserver/agenda?'+parametros).then((res)=>{
                    //console.log(res.data.data.dias);
                    this.agenda_virtual = res.data.data.dias;
                    this.funcionario.nombres    = res.data.data.funcionario;
                    this.funcionario.foto       = res.data.data.foto;
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
        },
    }
</script>